import React from 'react';
import { FloatingInput } from '../../shared/custom-ui';
import FormSectionSkeleton from '../../shared/custom-ui/skeleton/FormSectionSkeleton/FormSectionSkeleton';
import usePatientSectionData from '../../hooks/usePatientSectionData';
import EditSaveCancelButtons from './EditSaveCancelButtons';

export default function AdministrativeDetails({ Patientid, fields }) {
    const sectionKey = 'administrativeDetails';
    const {
        formData,
        editMode,
        loading,
        updating,
        setEditMode,
        handleInputChange,
        handleSave,
        handleCancel,
        hasChanges,
    } = usePatientSectionData(Patientid, fields, sectionKey);

    const fieldMap = [
        { label: 'Insurance Provider', key: 'insuranceProvider' },
        { label: 'Policy Number', key: 'policyNumber' },
        { label: 'Healthcare Provider', key: 'registeredHealthcareProvider' },
        { label: 'First Visit Date', key: 'dateOfInitialRegistration', type: 'date' },
    ];

    if (loading) {
        return <FormSectionSkeleton fields={4} title="Administrative Details" />;
    }

    return (
        <section className="flex h-full flex-col rounded-xl shadow-lg border" style={{ background: 'var(--bg-card)', borderColor: 'var(--border-subtle)' }}>
            {/* Enhanced Header */}
            <div className="sticky top-0 z-10 border-b px-6 py-4 rounded-t-[var(--radius-lg)] flex items-center justify-between" style={{ background: 'var(--primary-25)', borderColor: 'var(--border-subtle)' }}>
                <h2 className="text-lg font-bold">Administrative Details</h2>
            </div>

            {/* Enhanced Form Section */}
            <div
                className={`relative flex-1 px-6 py-4 ${updating ? 'overflow-hidden' : 'overflow-y-auto custom-scrollbar max-h-[calc(100vh-440px)]'}`}
            >
                <div className={`${updating ? 'pointer-events-none opacity-50' : ''}`}>
                    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
                        {fieldMap.map(({ label, key, type }) => (
                            <FloatingInput
                                key={key}
                                label={label}
                                name={key}
                                value={formData?.[key] || ''}
                                onChange={handleInputChange}
                                readOnly={!editMode}
                                type={type}
                            />
                        ))}
                    </div>
                </div>

                {/* Updating overlay */}
                {updating && (
                    <div className="absolute inset-0 z-20 flex items-center justify-center rounded-xl" style={{ background: 'var(--bg-card)', opacity: 0.7 }}>
                        <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-200" style={{ borderTopColor: 'var(--primary-600)' }} />
                    </div>
                )}
            </div>

            {/* Enhanced Footer */}
            <div className="sticky bottom-0 z-10 px-6 py-4 border-t rounded-b-[var(--radius-lg)]" style={{ background: 'var(--bg-surface)', borderColor: 'var(--border-subtle)' }}>
                <EditSaveCancelButtons
                    editMode={editMode}
                    updating={updating}
                    loading={loading}
                    hasChanges={hasChanges}
                    onEdit={() => setEditMode(true)}
                    onSave={handleSave}
                    onCancel={handleCancel}
                />
            </div>
        </section>
    );
}
